export default {
  add_rate: 'Aggiungi tariffa',
  remove_rate: 'Rimuovi tariffa',
  gateways: {
    adyen: 'Adyen',
  },
  methods: {
    fallback: 'Qualsiasi metodo di pagamento',
    card: 'Carta',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    link: 'Link',
    paypal: 'PayPal',
    pay_by_bank: 'Pay by Bank',
    sepa_debit: 'Addebito diretto SEPA',
    sofort: 'Sofort',
    giropay: 'giropay',
    bacs_debit: 'Addebito diretto Bacs',
    stripe_other: 'Altri metodi Stripe',
  },
  fields: {
    percentage: 'Percentuale',
    fixed: 'Importo fisso',
    min: 'Importo minimo',
  },
  // Spelled out from the row's own values, so a rate reads as the fee it
  // produces. {{method}} is the payment method, {{fixed}}/{{floor}} are
  // formatted amounts, {{percentage}} is a plain number.
  explanation: {
    none: 'Su {{method}} non viene ancora addebitato nulla: questi pagamenti hanno un margine dello 0% finché non viene impostata una tariffa.',
    floor_only:
      "Su {{method}} la commissione di elaborazione è di {{floor}} per ogni pagamento, indipendentemente dal totale dell'ordine.",
    percentage: "Su {{method}} la commissione di elaborazione è il {{percentage}}% del totale dell'ordine.",
    percentage_floor:
      "Su {{method}} la commissione di elaborazione è il {{percentage}}% del totale dell'ordine, con un minimo di {{floor}}.",
    fixed: 'Su {{method}} la commissione di elaborazione è di {{fixed}} per pagamento.',
    fixed_floor:
      'Su {{method}} la commissione di elaborazione è di {{fixed}} per pagamento, con un minimo di {{floor}}.',
    combined:
      "Su {{method}} la commissione di elaborazione è di {{fixed}} fissi più il {{percentage}}% del totale dell'ordine.",
    combined_floor:
      "Su {{method}} la commissione di elaborazione è di {{fixed}} fissi più il {{percentage}}% del totale dell'ordine, con un minimo di {{floor}}.",
    redundant_floor:
      "Il minimo di {{floor}} non ha mai effetto: l'importo fisso lo raggiunge già a ogni pagamento. Impostalo sopra {{fixed}} o cancellalo.",
  },
  example: 'Esempio: su un ordine di {{total}} la commissione di elaborazione è {{fee}}.',
};
